var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('page-footer-layout');
import { breakpoints, theme } from '@shapeable/theme';
import { useFooterMenu } from '../hooks/use-footer-menu';
import { sprintf } from 'sprintf-js';
import { useSiteFooter } from '../hooks/use-site-footer';
import { PoweredByShapeableLogo } from '../elements/powered-by-shapeable-logo';
import { SliceLayoutBoundary } from './slice-layout';
import { SiteLogo } from './site-logo';
import { MenuNavigation } from './menu-navigation';
import { SocialLinks } from '../elements/social-links';
import { useEntity } from '../hooks/use-entity';
import { useSite } from '../hooks/use-site';
import { useLang } from '../hooks/use-lang';
import { useLink } from '../hooks/use-link';
import { useSiteOwnerName } from '../hooks/use-site-owner-name';
export var PageFooterLayoutDefaultProps = {
  backgroundColor: '#F5F5F5',
  poweredBylogoProps: {}
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["  \n    ", "\n    font-weight: 300;\n    padding: ", " ", ";\n  "], ["  \n    ", "\n    font-weight: 300;\n    padding: ", " ", ";\n  "])), function (_a) {
    var _backgroundColor = _a._backgroundColor;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), theme.COLOR(_backgroundColor));
  }, theme.UNIT(8), theme.UNIT(4)),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", ";\n    padding: ", " ", ";\n  "], ["\n    font-size: ", ";\n    padding: ", " ", ";\n  "])), theme.FONT_SIZE(13), theme.UNIT(12), theme.UNIT(4)),
  desktop: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: ", " ", ";\n  "], ["\n    padding: ", " ", ";\n  "])), theme.UNIT(14), theme.UNIT(6))
});
var BoundaryStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LayoutStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    flex-grow: 1;\n    align-self: stretch;\n    font-size: ", ";\n    justify-content: space-between;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    flex-grow: 1;\n    align-self: stretch;\n    font-size: ", ";\n    justify-content: space-between;\n  "])), theme.FONT_SIZE(12)),
  tablet: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    flex-direction: row;\n    align-items: center;\n  "], ["\n    flex-direction: row;\n    align-items: center;\n  "])))
});
var LogoStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    width: 180px;\n    height: auto;\n    margin-bottom: ", ";\n  "], ["\n    width: 180px;\n    height: auto;\n    margin-bottom: ", ";\n  "])), theme.UNIT(4)),
  tablet: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    width: 160px;\n    margin-bottom: 0;\n  "], ["\n    width: 160px;\n    margin-bottom: 0;\n  "]))),
  desktop: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    width: 220px;\n  "], ["\n    width: 220px;\n  "]))),
  desktopLarge: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    width: 220px;\n  "], ["\n    width: 220px;\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    margin-bottom: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    margin-bottom: ", ";\n  "])), theme.UNIT(6)),
  tablet: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    margin-bottom: 0;\n    align-items: center;\n    padding: 0 ", ";\n\n  "], ["\n    margin-bottom: 0;\n    align-items: center;\n    padding: 0 ", ";\n\n  "])), theme.UNIT(10))
});
var NavigationStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    font-weight: 500;\n    font-size: 1em;\n    height: ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n    li:first-child {\n      margin-left: 0;\n    }\n\n  "], ["\n    font-weight: 500;\n    font-size: 1em;\n    height: ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n    li:first-child {\n      margin-left: 0;\n    }\n\n  "])), theme.UNIT(6), theme.UNIT(4), theme.UNIT(2)),
  tablet: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    margin-top: 0;\n    \n  "], ["\n    margin-top: 0;\n    \n  "])))
});
var CreditLogoStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    width: 160px;\n  "], ["\n    width: 160px;\n  "]))),
  tablet: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    width: 180px;\n  "], ["\n    width: 180px;\n  "])))
});
var CopyrightStyles = breakpoints({
  base: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    color: ", ";\n    margin-bottom: ", ";\n  "], ["\n    color: ", ";\n    margin-bottom: ", ";\n  "])), theme.COLOR('text'), theme.UNIT(4))
});
var SocialLinksStyles = breakpoints({
  base: css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Boundary: styled(SliceLayoutBoundary)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), BoundaryStyles),
  Layout: styled.div.attrs(cls.attr('layout'))(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Logo: styled(SiteLogo)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), LogoStyles),
  CreditLogo: styled(PoweredByShapeableLogo)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), CreditLogoStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Navigation: styled(MenuNavigation)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), NavigationStyles),
  Copyright: styled.span.attrs(cls.attr('copyright'))(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), CopyrightStyles),
  SocialLinks: styled(SocialLinks)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), SocialLinksStyles)
};
export var PageFooterLayout = function (props) {
  var className = props.className,
    children = props.children,
    logoVariant = props.logoVariant,
    backgroundColor = props.backgroundColor,
    poweredBylogoProps = props.poweredBylogoProps;
  var entity = useEntity(props.entity);
  var menu = useFooterMenu();
  var footer = useSiteFooter();
  var site = useSite();
  var t = useLang();
  var Link = useLink().Link;
  var siteOwnerName = useSiteOwnerName();
  var orgName = props.orgName || siteOwnerName;
  console.log(footer);
  return React.createElement(My.Container, {
    _backgroundColor: backgroundColor
  }, React.createElement(My.Boundary, {
    boundary: footer.boundary
  }, React.createElement(My.Layout, {
    className: cls.name(className)
  }, React.createElement(My.Logo, {
    variant: logoVariant
  }), React.createElement(My.Body, null, menu && React.createElement(My.Navigation, {
    color: "text",
    stackOnMobile: false,
    showDividers: true,
    dividerColor: "secondary",
    entity: menu
  }), React.createElement(My.Copyright, null, "\u00A9 ", sprintf(t('%s %s. All rights reserved'), new Date().getFullYear(), orgName || '')), children, React.createElement(My.SocialLinks, null)), React.createElement(Link, {
    href: "https://shapeable.ai"
  }, React.createElement(My.CreditLogo, __assign({}, poweredBylogoProps))))));
};
PageFooterLayout.defaultProps = PageFooterLayoutDefaultProps;
PageFooterLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28;